import { IMAGES } from "../constent/theme";
import CommonBanner from "../elements/CommonBanner";
import ModalVideoBox from "../elements/ModalVideoBox";
import { AboutServiceArr } from "../elements/JsonData";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import { useEffect } from "react";

const AboutUs = () => {
  useEffect(() => {
    document.body.setAttribute("data-color", "color_3");
  }, []);
  return (
    <div className="page-content bg-white">
    <Header />

      <ModalVideoBox />
      <section className="content-inner">
        <div className="container mt-5">
          <div className="section-head text-center">
            <h2 className="title">What We Do</h2>
          </div>
          <div className="row">
            {AboutServiceArr.map(({ icon, title }, ind) => (
              <div className="col-lg-3 col-sm-6 m-b30" key={ind}>
                <div className="icon-bx-wraper style-3">
                  <div className="icon-bx">
                    <div className="icon-cell">
                      <i className={icon}></i>
                    </div>
                  </div>
                  <div className="icon-content">
                    <h5 className="title">
                      <Link to="/service-detail">{title}</Link>
                    </h5>
                    <p>Lorem Ipsum is simply dummy text of the printing and </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
